module.exports = __webpack_public_path__ + "static/sentry-d16aaf48e64ea2fd654ba3d08a2e048d.png";